import { booleanAttribute, Component, input } from '@angular/core';


@Component({
  selector: 'mui-list',
  template: `
    <ng-content select="mui-list-header"></ng-content>
    <ng-content select="mui-list-item"></ng-content>
  `,
  styleUrl: './mui-list.component.scss',
  host: {
    /* eslint-disable  @typescript-eslint/naming-convention */
    'role': 'list',
    '[attr.id]': 'id()',
    '[attr.aria-labelledby]': 'id() + "_title"'
    /* eslint-enable  @typescript-eslint/naming-convention */
  }
})
export class MuiList {
  static uid = 0;
  id = input<string>('mui-list-' + MuiList.uid++);
  dense = input(false, { transform: booleanAttribute });
}
